<!--
 * @Author: wangjiaxiang
 * @Date: 2022-03-16 15:38:10
 * @LastEditTime: 2022-05-05 10:56:55
 * @LastEditors: Please set LastEditors
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/components/audioInfo.vue
 *
-->

<template>
  <div>
    <!-- 音频播放器 -->
    <audio
        id="audio"
        ref="audio"
        :loop="isButtonDisable <= 1 ? true : false"
        preload="auto"
    ></audio>
    <!-- 音频信息展示 -->
    <div class="audio-info">
      <!-- 头部 -->
      <div class="audio-img">
        <img :src="audioInfo.coverUrl" alt />
      </div>
      <!-- 标题 -->
      <div class="audio-title">
        <span>{{
          audioInfo.title && audioInfo.title.indexOf(".mp3") == -1
            ? audioInfo.title
            : audioInfo.name
        }}</span>
      </div>
      <!-- 音频进度条 -->
      <div class="audio-slider">
        <div>{{ audioDuration }}</div>
        <van-slider
            v-model="audioTime"
            :disabled="false"
            :max="totalAudioDuration"
            :min="0"
            active-color="#E7C999"
            inactive-color="#DDDDDD"
            @change="onChange"
        />
        <div>{{ endTime || "00:00" }}</div>
      </div>
      <!-- 开始暂停切换播放 -->
      <div class="audio-control">
        <img
            :class="['audio-speed', isButtonDisable <= 1 ? 'button-disable' : '']"
            src="@/assets/images/icon/audio_prev.png"
            @click.stop="isButtonDisable <= 1 ? '' : prevAudio()"
        />
        <img
            :src="
            playStatus
              ? require('@/assets/images/icon/audio_end2.png')
              : require('@/assets/images/icon/audio_start2.png')
          "
            class="audio-start"
            @click="startPlayer"
        />

        <img
            :class="['audio-speed', isButtonDisable <= 1 ? 'button-disable' : '']"
            src="@/assets/images/icon/audio_next_detail.png"
            @click.stop="isButtonDisable <= 1 ? '' : nextAudio()"
        />
      </div>
    </div>
  </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.0.0.js"></script>
<script>
// 方法
import {Debounce, is_weixin, isUserLogin, TestUserAgent,} from "@/assets/js/common.js";
import {inquireTime} from '@/utils/newMemberApiGlobal'
import wx from "weixin-js-sdk";

export default {
  name: "audioInfo",
  components: {},
  props: ["audioInfo", "isButtonDisable"],
  data() {
    return {
      audioTime: 0, //音频当前播放时长控制进度条
      audioDuration: "00:00", //音频当前播放时长控制显示时长
      playStatus: false, // 当前播放状态
      totalAudioDuration: 1, //进度条最大长度
      endTime: "", //音频的结束时间
      time: 0, // 实时时间
      readingArticleDuration: 10
    };
  },
  computed: {
    isGoLogin() {
      return isUserLogin();
    },
  },
  created() {
    inquireTime(res => {
      this.readingArticleDuration = res.readingArticleDuration
    }, this)
  },
  beforeDestroy() {
    this.$refs.audio.pause();
  },
  mounted() {
    // this.watchMusicTime();
    var that = this;
    this.$nextTick(() => {
      this.$http.get(
          "/wechat/oauth2/getJSSDKConfig?url=" +
          encodeURIComponent(location.href.split("#")[0]),
        {},
        (res) => {
          console.log(res);
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            openTagList: ["wx-open-launch-weapp"],
            jsApiList: [],
          });
          wx.ready(function() {
            var audio = document.getElementById("audio");
            audio.play();
          });
        }
      );
    });
  },
  watch: {
    audioInfo: {
      handler(newValue, oldVal) {
        if (newValue.id !== oldVal.id) {
          console.log(newValue);
          let _this = this;
          //监听播放时间
          let musicDom = this.$refs.audio; //获取Audio的DOM节点
          this.$nextTick(()=>{
            musicDom.load();
          })
          musicDom.src = newValue.contentUrl;
          //监听audio是否加载完毕，如果加载完毕，则读取audio播放时间
          this.$nextTick(() => {
            musicDom.addEventListener("canplay", function () {
              // 获取总时长进度条最大长度
              _this.totalAudioDuration = isNaN(musicDom.duration)
                  ? -1
                  : Math.ceil(musicDom.duration);
              _this.endTime = _this.convertMinutes(_this.totalAudioDuration);
            });
          })
          _this.watchMusicTime();
          this.autoplayAudio();
          musicDom.autoplay = true;
        }
      },
      deep: true,
    },
    time: {
      handler(newValue, oldVal) {
        // 判断是否登陆
        if (newValue >= 10) {
          // this.$emit("isUserLogin");
        }
        // 10秒增加成长值
        if (newValue == this.readingArticleDuration) {
          this.$emit("taskFinish");
        }
      },
    },
  },
  methods: {
    // 自动播放
    autoplayAudio() {
      let music = document.getElementById("audio");
      if (is_weixin) {
        if (window.WeixinJSBridge) {
          WeixinJSBridge.invoke(
              "getNetworkType",
              {},
              function (e) {
                music.play();
                document.addEventListener(
                    "WeixinJSBridgeReady",
                    function () {
                      document.getElementById("audio").play();
                      // document.getElementById('video').play();
                    },
                    false
                );
              },
              false
          );
        } else {
          document.addEventListener(
              "WeixinJSBridgeReady",
              function () {
                WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
                  music.play();
                });
              },
              false
          );
        }
      } else {
        music.play();
      }
      // 分享进来
      if (this.$route.query.share) {
        // 判断是安卓的分享进来自动播放不了
        const {isAndroid} = TestUserAgent();
        if (isAndroid) {
          this.playStatus = false;
        } else {
          this.playStatus = true;
        }
      } else {
        this.playStatus = true;
      }
    },
    // 滑动改变时候赋值
    onChange(val) {
      console.log(val);
      this.$refs.audio.currentTime = val;
    },
    // 开始播放
    startPlayer() {
      this.playStatus = !this.playStatus;
      if (this.playStatus) {
        this.$refs.audio.play();
        // this.audioTime();
        // this.$emit("playSensor", "开始");
      } else {
        // this.endClick();
        this.$refs.audio.pause();

        // this.$emit("playSensor", "暂停");
      }
    },
    //监听音乐实时播放的时间
    watchMusicTime() {
      let _this = this;
      //监听播放时间
      let musicDom = this.$refs.audio; //获取Audio的DOM节点
      //使用事件监听方式捕捉事件
      musicDom.addEventListener(
          "timeupdate",
          function () {
            //监听音频播放的实时时间事件
            let timeDisplay;
            //用秒数来显示当前播放进度
            timeDisplay = Math.ceil(musicDom.currentTime); //获取实时时间
            // 实时时间
            _this.time = timeDisplay;

            //处理时间
            //分钟
            let minute = timeDisplay / 60;
            let minutes = parseInt(minute);
            if (minutes < 10) {
              minutes = "0" + minutes;
            }
            //秒
            let second = timeDisplay % 60;
            let seconds = Math.round(second);
            if (seconds < 10) {
              seconds = "0" + seconds;
            }
            // 进度条当前时长
            _this.audioTime = timeDisplay;
            // 左边显示当前播放时长
            _this.audioDuration = minutes + ":" + seconds;
          },
          false
      );
      // 监听音频播放完毕切换
      musicDom.addEventListener(
          "ended",
          function () {
            _this.$emit("audioSwitch", _this.audioInfo.id);
          },
          false
      );
    },
    // 音频切换下一首
    nextAudio: Debounce(function () {
      this.$refs.audio.pause();
      this.$refs.audio.currentTime = 0;
      this.$emit("audioSwitch", this.audioInfo.id);
    }, 500),
    // 音频切换上一首
    prevAudio: Debounce(function () {
      this.$emit("prevAudio", this.audioInfo.id);
    }, 500),
    /**
     * @description: 转换音频时长为分钟
     * @param {number} time 音频总时长
     * @return {*}
     */

    convertMinutes(time) {
      var minute = parseInt(time / 60);
      var sec = (time % 60) + "";
      var isM0 = ":";
      if (minute == 0) {
        undefined;
        minute = "00";
      } else if (minute < 10) {
        undefined;
        minute = "0" + minute;
      }
      if (sec.length == 1) {
        undefined;
        sec = "0" + sec;
      }
      return minute + isM0 + sec;
    },
  },
};
</script>

<style lang="less" scoped>
// 音频信息展示
.audio-info {
  .audio-img {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    padding: 20px 0;

    img {
      width: 100%;
      height: 100%;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 8px;
    }
  }

  .audio-title {
    padding: 0 40px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 16px;
    text-align: center;

    span {
      text-align: justify;
      display: inline-block;
    }
  }

  .audio-slider {
    display: flex;
    padding: 0 10px;
    align-items: center;
    height: 70px;
    margin-bottom: 5px;

    .van-slider {
      width: 80%;
      margin: 0 8px 0 13px;
    }

    /deep/ .van-slider__button {
      width: 16px;
      height: 16px;
    }

    /deep/ .van-slider__bar {
      transition: all 0.5s;
    }
  }

  .audio-control {
    width: 150px;
    margin: 0 auto;
    display: flex;
    margin-bottom: 15px;
    justify-content: space-around;
    align-items: center;

    .audio-speed {
      width: 26px;
      height: 26px;
    }

    .audio-start {
      width: 42px;
      height: 42px;
    }
  }

  .button-disable {
    opacity: 0.5;
  }
}
</style>
